import React from 'react';

const Footer = () => {
    return (
        <React.Fragment>
            <footer className="footer">
                <div className="w-full px-6">
                    <div className="flex flex-wrap -mx-3 text-sm text-slate-600">
                        <div className="w-full sm:w-1/2 px-3">
                            {new Date().getFullYear()} © AmazingInfra.
                        </div>
                        <div className="hidden w-full sm:block sm:w-1/2 px-3 text-right">
                            
                        </div>
                    </div>
                </div>
            </footer>
        </React.Fragment>
    );
};

export default Footer;